import { actionType } from "../actions/aktorerActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const aktorerReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default aktorerReducer;
